// extracted by mini-css-extract-plugin
module.exports = {"CardBox":"Card-module--CardBox--3cFyS","CardText":"Card-module--CardText--2qBEB"};